export default __webpack_public_path__ + "static/media/googlePlay.bc8dee97.svg";